// extracted by mini-css-extract-plugin
export var blue = "_3v-h";
export var brand = "_3v-d";
export var darkGrey = "_3v-g";
export var disabled = "_3v-6";
export var disabledSubtle = "_3v-7";
export var error = "_3v-8";
export var green = "_3v-i";
export var grey = "_3v-f";
export var icon = "_3v-0";
export var inherit = "_3v-c";
export var lightGrey = "_3v-e";
export var orange = "_3v-k";
export var pink = "_3v-m";
export var primary = "_3v-1";
export var purple = "_3v-n";
export var quaternary = "_3v-4";
export var quinary = "_3v-5";
export var red = "_3v-l";
export var secondary = "_3v-2";
export var success = "_3v-b";
export var tertiary = "_3v-3";
export var warning = "_3v-9";
export var warningSecondary = "_3v-a";
export var white = "_3v-o";
export var yellow = "_3v-j";